import { defineMessages } from 'react-intl';

export default defineMessages({
  openNavigation: {
    id: 'features.appHeader.openNavigation',
    defaultMessage: 'Open menu',
  },
  platformAdmin: {
    id: 'features.appHeader.platformAdmin',
    defaultMessage: 'Platform admin',
  },
  superAdmin: {
    id: 'features.appHeader.superAdmin',
    defaultMessage: 'Super admin',
  },
});
